<div style="display:flex;flex-direction:column;gap:32px;padding:32px;">
    <app-header-benefits></app-header-benefits>
    <app-discover-benefits></app-discover-benefits>
    <app-faq-benefits></app-faq-benefits>
</div>
